(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cappture-story-photos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cappture-story-photos')) {
    class CapptureStoryPhotos extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) this.initialise();
        });
      }

      initialise() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('[data-story-photo]'));
        this.controls = this.querySelector('[data-story-photo-controls]');
        if (this.slides.length < 2 || !this.controls) return;
        this.dots = Array.from(this.querySelectorAll('[data-story-photo-go]'));
        this.playback = this.querySelector('[data-story-photo-playback]');
        this.status = this.querySelector('[data-story-photo-status]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.current = 0;
        this.request = (this.request || 0) + 1;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.visible = false;
        this.slides.forEach((slide) => { slide.hidden = false; });
        this.controls.hidden = false;
        this.querySelector('[data-story-photo-previous]').addEventListener('click', () => this.show(this.current - 1, true), options);
        this.querySelector('[data-story-photo-next]').addEventListener('click', () => this.show(this.current + 1, true), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true), options));
        this.playback.addEventListener('click', () => {
          this.playing = !this.playing;
          if (this.playing) {
            this.focused = false;
            this.hovered = false;
          }
          this.updatePlayback();
        }, options);
        this.controls.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.current + (event.key === 'ArrowLeft' ? -1 : 1);
          this.show(index, true);
        }, options);
        this.addEventListener('pointerenter', () => { this.hovered = true; this.refreshTimer(); }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.refreshTimer(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.refreshTimer(); }, options);
        this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.refreshTimer(); }, options);
        document.addEventListener('visibilitychange', () => this.refreshTimer(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.playing = false;
          this.updatePlayback();
        }, options);
        this.observer?.disconnect();
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.slides.forEach((slide) => { slide.querySelector('img').loading = 'eager'; });
          this.refreshTimer();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.slides[0].setAttribute('aria-hidden', 'false');
        this.updatePlayback();
      }

      async show(index, announce = false) {
        clearTimeout(this.timer);
        const next = (index + this.slides.length) % this.slides.length;
        const request = ++this.request;
        const image = this.slides[next].querySelector('img');
        if (!image.complete || image.naturalWidth === 0) {
          image.loading = 'eager';
          try { await image.decode(); } catch { this.refreshTimer(); return; }
          if (request !== this.request || !this.isConnected) return;
        }
        if (!announce && (!this.isConnected || !this.playing || !this.visible || this.hovered || this.focused || document.hidden)) return;
        this.current = next;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (announce) this.status.textContent = this.slides[this.current].dataset.announcement;
        this.refreshTimer();
      }

      updatePlayback() {
        const state = this.playing ? 'pause' : 'play';
        this.playback.textContent = this.playback.dataset[`${state}Text`];
        this.playback.setAttribute('aria-label', this.playback.dataset[`${state}Label`]);
        this.refreshTimer();
      }

      refreshTimer() {
        clearTimeout(this.timer);
        if (this.isConnected && this.playing && this.visible && !this.hovered && !this.focused && !document.hidden) {
          this.timer = setTimeout(() => this.show(this.current + 1), 5000);
        }
      }

      disconnectedCallback() {
        this.request += 1;
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.abort?.abort();
      }
    }
    customElements.define('cappture-story-photos', CapptureStoryPhotos);
  }
  } catch(e) { console.error(e); }
})();

})();
